import { createStore } from '@nile/mangifera/src/StoreManager/store/createStore';

interface AppViewPersonalization {
  isHistoricPatchesEnabled?: boolean;
  [key: string]: any;
}

const historicPatchStoreConfig = {
  id: 'historicPatch',
  initialState: {
    isHistoricPatchesEnabled: false,
    isInitialized: false
  },
  methods: (set, get) => ({
    setHistoricPatchesEnabled: (isEnabled: boolean) => {
      set({ isHistoricPatchesEnabled: isEnabled });
    },
    initializeFromAppContext: (
      appViewPersonalization: AppViewPersonalization | null
    ) => {
      // Only initialize once per session from appContext
      if (!get().isInitialized && appViewPersonalization) {
        const isEnabled =
          appViewPersonalization?.isHistoricPatchesEnabled || false;
        set({
          isHistoricPatchesEnabled: isEnabled,
          isInitialized: true
        });
      }
    },
    reset: () => {
      set({ isHistoricPatchesEnabled: false, isInitialized: false });
    }
  }),
  cache: {
    expiryTime: 300,
    strategy: 'memory',
    tabBehavior: 'persist',
    clearOnRefresh: true,
    scope: 'global'
  }
};

export const useHistoricPatchStore = createStore(historicPatchStoreConfig);
